/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
     ModelConfigurationFromJSONTyped,
     CreateConfigurationRequestFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface UpdateConfigurationRequest
 */
export interface UpdateConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateConfigurationRequest
     */
    configurationName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateConfigurationRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateConfigurationRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateConfigurationRequest
     */
    forceSave?: boolean;
}

/**
 * Check if a given object implements the UpdateConfigurationRequest interface.
 */
export function instanceOfUpdateConfigurationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "configurationName" in value;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function UpdateConfigurationRequestFromJSON(json: any): UpdateConfigurationRequest {
    return UpdateConfigurationRequestFromJSONTyped(json, false);
}

export function UpdateConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConfigurationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['openApiType'] === 'Configuration') {
            return ModelConfigurationFromJSONTyped(json, true);
        }
        if (json['openApiType'] === 'CreateConfigurationRequest') {
            return CreateConfigurationRequestFromJSONTyped(json, true);
        }
    }
    return {
        
        'configurationName': json['configurationName'],
        'value': json['value'],
        'description': json['description'],
        'forceSave': !exists(json, 'forceSave') ? undefined : json['forceSave'],
    };
}

export function UpdateConfigurationRequestToJSON(value?: UpdateConfigurationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'configurationName': value.configurationName,
        'value': value.value,
        'description': value.description,
        'forceSave': value.forceSave,
    };
}

